import React from 'react';
import logo from '../../../../images/logo.webp';
import tuAkceptujeme from '../../../../images/tu akceptujeme.webp';
import buger from '../../../../images/burger.webp';
import {getAppendedClassWithDevice} from '../../../../shared/utils/deviceUtils';
import './Banner.scss';

type BannerParameters = {
    isMobile?: boolean;
    displayAsFooter?: boolean;
};

export const Banner = (params: BannerParameters = {
    isMobile: false,
    displayAsFooter: false
}) =>
    (
        <div className={getAppendedClassWithDevice('banner', params.isMobile)}>
            {!params.displayAsFooter && (
                <img src={logo} className={getAppendedClassWithDevice("logo", params.isMobile)} alt="logo"/>)}
            {(!params.isMobile || params.displayAsFooter) && (
                <img src={tuAkceptujeme} className="we-accept" alt="we_accept"/>)}
            {(!params.isMobile || params.displayAsFooter) && (<img src={buger} className="burger" alt="we_accept"/>)}
        </div>
    );
